export default {
  intro: `Bitte legen Sie die Karte auf das Lesegerät auf Ihrer linken Seite. Warten Sie 5 Sekunden, die Schlüsselkarte wird dabei erzeugt. Danach können Sie die Karte wieder entfernen.`,
};
